import React, { useContext } from 'react'
import Color from 'app/react/components/colors/Color'
import ColorsContext from 'app/react/components/colors/ColorsContext'
import classNames from 'classnames'

export default function Colors () {

  const { colors } = useContext(ColorsContext)

  if (colors.length === 0) return

  return (
    <div className={classNames('dm-colors__colors', {
      'dm-colors__colors--four-or-less': colors.length <= 4,
      'dm-colors__colors--seven-or-more': colors.length > 7
    })}>
      {colors.map((color, i) => <Color key={i} {...color} />)}
    </div>
  )
}